/**
 * ReplyComposerBar — bar above the chat input showing what the agent
 * is replying to. ✕ cancels reply mode. WhatsApp style.
 *
 * Phase 2 (owner-spec 2026-05-31). Controlled by the parent — receives
 * `replyTarget` (or null) and `onCancel`. When null/falsy the bar
 * doesn't render.
 *
 * The replyTarget shape MUST be compatible with what's serialised
 * into `replyTo` on send:
 *   { id, body, type, mediaType, mediaUrl, senderName, fromMe }
 */

import React from 'react';

const MEDIA_LABELS = {
  image: '📷 תמונה',
  video: '🎬 וידאו',
  audio: '🎵 אודיו',
  voice: '🎤 הקלטה',
  document: '📄 מסמך',
};

const truncate = (s, n) => (s && s.length > n ? s.slice(0, n) + '…' : (s || ''));

const ReplyComposerBar = ({ replyTarget, onCancel }) => {
  if (!replyTarget) return null;
  const mediaKey = (replyTarget.mediaType || replyTarget.type || '').toLowerCase();
  const mediaLabel = MEDIA_LABELS[mediaKey];
  const isFromMe = !!replyTarget.fromMe;
  const senderName = replyTarget.senderName || (isFromMe ? 'נציג' : 'לקוח');
  const preview = mediaLabel
    ? `${mediaLabel}${replyTarget.body ? ` · ${truncate(replyTarget.body, 60)}` : ''}`
    : truncate(replyTarget.body || '(הודעה ריקה)', 80);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '8px 12px',
        background: '#f0f2f5',
        borderRight: `4px solid ${isFromMe ? '#128c7e' : '#1565c0'}`,
        borderBottom: '1px solid #ddd',
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '11px',
          fontWeight: 600,
          color: isFromMe ? '#128c7e' : '#1565c0',
          marginBottom: '2px',
        }}>
          תגובה ל{senderName}
        </div>
        <div style={{
          fontSize: '13px',
          color: '#444',
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {preview}
        </div>
      </div>
      {replyTarget.mediaUrl && mediaKey === 'image' && (
        <img
          src={replyTarget.mediaUrl}
          alt=""
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '4px',
            objectFit: 'cover',
          }}
        />
      )}
      <button
        onClick={onCancel}
        title="בטל תגובה"
        style={{
          background: 'none',
          border: 'none',
          fontSize: '18px',
          cursor: 'pointer',
          color: '#666',
          padding: '4px 6px',
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default ReplyComposerBar;
